
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  font-family:var(--ff-display);

  --heading-mb-sm:0.375rem;
  --heading-mb-lg:0.75rem;
  --heading-color-default:var(--brand-gray-900);
}

.ruled::after, :host([ruled])::after{
    content:'';
    border-radius:8px;
    border-radius:var(--ruled-border-radius, 8px);
    border:solid var(--brand-green-900);
    border-width:8px 0 0;
    border-width:var(--ruled-border-width, 8px) 0 0;
    display:block;
    height:0.0625rem;
    margin:0;
    max-width:5.3125rem;
    max-width:var(--ruled-max-width, 5.3125rem);
    padding:0;
    position:relative;
    text-align:left;
    width:100%;
  }

:host([accent-color='blue_zodiac'])::after{
    border-color:var(--brand-blue-zodiac);
  }

:host([accent-color='cornflower_blue'])::after{
    border-color:var(--brand-cornflower-blue);
  }

:host([accent-color='dark_blue'])::after{
    border-color:var(--brand-dark-blue);
  }

:host([accent-color='light_blue'])::after{
    border-color:var(--brand-light-blue);
  }

:host([accent-color='green'])::after{
    border-color:var(--brand-green);
  }

:host([accent-color='fun_green'])::after{
    border-color:var(--brand-fun-green);
  }

:host([accent-color='orange'])::after{
    border-color:var(--brand-orange);
  }

:host([accent-color='red'])::after{
    border-color:var(--brand-red);
  }

:host([accent-color='dark_red'])::after{
    border-color:var(--brand-dark-red);
  }

:host([accent-color='dark_gray'])::after{
    border-color:var(--brand-dark-gray);
  }

:host([accent-color='dove_gray'])::after{
    border-color:var(--brand-dove-gray);
  }

:host([accent-color='gray_70'])::after{
    border-color:var(--brand-gray-70);
  }

:host([accent-color='gray_80'])::after{
    border-color:var(--brand-gray-80);
  }

:host([accent-color='gray_90'])::after{
    border-color:var(--brand-gray-90);
  }

:host([accent-color='gray_100'])::after{
    border-color:var(--brand-black);
  }

a{
  --link-color-default:var(--brand-primary-dark-blue);
  --link-color-hover:var(--brand-primary-dark-blue);
  --link-background-color-hover:var(--brand-primary-green);
  transition:0.3s ease all;
}

a:hover,
  a:focus{
    outline:none;
    color:var(--link-color-hover);
    background-color:var(--link-background-color-hover);
  }

a:focus{
    border-top:1px solid var(--link-color-default);
  }

.border-bottom,
:host([has-border-bottom]){
  border-bottom:3px solid var(--brand-primary-dark-blue);
  padding-bottom:var(--spacing-5);
  margin-bottom:var(--spacing-5);
}

.heading-color-blue,
:host([level-color='blue']){
  --heading-color:var(--brand-primary-dark-blue);
}

.heading-color-white,
:host([level-color='white']){
  --heading-color:var(--brand-white);
}

h1,
h2,
h3,
h4,
h5,
h6,
.heading-style-3xl,
.heading-style-2xl,
.heading-style-xl,
.heading-style-lg,
.heading-style-md,
.heading-style-sm,
.heading-style-xs{
  color:var(--heading-color-default);
  color:var(--heading-color, var(--heading-color-default));
  font-family:var(--ff-display);
  font-weight:var(--fw-bold);
  font-weight:var(--heading-font-weight, var(--fw-bold));
  margin-bottom:var(--lh-xs);
  margin-bottom:var(--heading-mb-lg, var(--lh-xs));
}

h1{
  font-size:var(--fs-headline-3xl-responsive);
  line-height:var(--lh-headline-3xl);
}

h2{
  font-size:var(--fs-headline-2xl-responsive);
  line-height:var(--lh-headline-2xl);
}

h3{
  font-size:var(--fs-headline-xl-responsive);
  line-height:var(--lh-headline-xl);
}

h4{
  font-size:var(--fs-headline-lg-responsive);
  line-height:var(--lh-headline-lg);
}

h5{
  font-size:var(--fs-headline-md-responsive);
  line-height:var(--lh-headline-md);
}

h6{
  font-size:var(--fs-headline-sm-responsive);
  line-height:var(--lh-headline-sm);
}

.heading-style-xs,
:host([level-size='2xs']),
:host([level-size='2xs']) *{
  font-size:var(--fs-headline-2xs-responsive);
  line-height:var(--lh-headline-2xs);
}

.heading-style-xs,
:host([level-size='xs']),
:host([level-size='xs']) *{
  font-size:var(--fs-headline-xs-responsive);
  line-height:var(--lh-headline-xs);
}

.heading-style-sm,
:host([level-size='sm']),
:host([level-size='sm']) *{
  font-size:var(--fs-headline-sm-responsive);
  line-height:var(--lh-headline-sm);
}

.heading-style-md,
:host([level-size='md']),
:host([level-size='md']) *{
  font-size:var(--fs-headline-md-responsive);
  line-height:var(--lh-headline-md);
}

.heading-style-lg,
:host([level-size='lg']),
:host([level-size='lg']) *{
  font-size:var(--fs-headline-lg-responsive);
  line-height:var(--lh-headline-lg);
}

.heading-style-xl,
:host([level-size='xl']),
:host([level-size='xl']) *{
  font-size:var(--fs-headline-xl-responsive);
  line-height:var(--lh-headline-xl);
}

.heading-style-2xl,
:host([level-size='2xl']),
:host([level-size='2xl']) *{
  font-size:var(--fs-headline-2xl-responsive);
  line-height:var(--lh-headline-2xl);
}

.heading-style-3xl,
:host([level-size='3xl']),
:host([level-size='3xl']) *{
  font-size:var(--fs-headline-3xl-responsive);
  line-height:var(--lh-headline-3xl);
}

.heading-style-4xl,
:host([level-size='4xl']),
:host([level-size='4xl']) *{
  font-size:var(--fs-headline-4xl-responsive);
  line-height:var(--lh-headline-4xl);
}

:host([level-style='normal']),
:host([level-style='normal']) *{
  font-weight:var(--fw-normal);
}

:host([level-style='bold']),
:host([level-style='bold']) *{
  font-weight:var(--fw-bold);
  font-weight:var(--heading-font-weight, var(--fw-bold));
}

:host([level-style='extrabold']),
:host([level-style='extrabold']) *{
  font-family:var(--ff-bold);
}

:host([level-style='eyebrow']) h2,
:host([level-style='eyebrow']) h3,
:host([level-style='eyebrow']) h4,
:host([level-style='eyebrow']) h5,
:host([level-style='eyebrow']) h6{
  background-color:var(--brand-green);
  color:var(--brand-dark-blue);
  font-family:var(--ff-bold);
  font-size:var(--fs-headline-sm-responsive);
  line-height:var(--lh-xs);
  text-transform:uppercase;
  display:inline-block;
  padding:var(--spacing-2) var(--spacing-3);
}
`;